
export default {
  // Header
  "logo_alt": "onexip Logo",
  
  // Calculator
  "calculator_title": "Projektkostenrechner",
  "calculator_subtitle": "Beantworten Sie einige Fragen zu Ihren Projektanforderungen, um eine detaillierte Kostenschätzung zu erhalten.",
  
  // Platforms Step
  "platform_title": "Welche Plattformen möchten Sie unterstützen?",
  "platform_subtitle": "Wählen Sie eine oder mehrere Plattformen für Ihre Anwendung",
  "platform_ios": "iOS",
  "platform_android": "Android",
  "platform_web": "Web",
  "platform_cross": "Plattformübergreifend",
  
  // App Type Step
  "apptype_title": "Welche Art von App benötigen Sie?",
  "apptype_subtitle": "Wählen Sie die Komplexitätsstufe für Ihre Anwendung",
  "apptype_mvp": "MVP",
  "apptype_mvp_desc": "Basis-App mit wesentlichen Funktionen zur Validierung Ihrer Idee",
  "apptype_full": "Voll ausgestattet",
  "apptype_full_desc": "Komplette App mit umfassenden Funktionen und verfeinerter Benutzerführung",
  "apptype_enterprise": "Enterprise",
  "apptype_enterprise_desc": "Robuste Lösung mit erweiterten Funktionen für den Großeinsatz",
  
  // Features Step
  "features_title": "Welche Funktionen benötigen Sie?",
  "features_subtitle": "Wählen Sie die Funktionen für Ihre Anwendung",
  "feature_auth": "Benutzerauthentifizierung",
  "feature_auth_desc": "Anmeldung, Registrierung und Benutzerverwaltung",
  "feature_logo": "Logo-Design",
  "feature_logo_desc": "Professionelles Logo-Design für Ihre App",
  "feature_ui": "Benutzerdefiniertes UI/UX-Design",
  "feature_ui_desc": "Einzigartiges, gebrandetes Interface-Design",
  "feature_chat": "Echtzeit-Chat",
  "feature_chat_desc": "Sofortnachrichten zwischen Benutzern",
  "feature_payments": "Zahlungen/In-App-Käufe",
  "feature_payments_desc": "Zahlungen verarbeiten und Transaktionen abwickeln",
  "feature_gps": "GPS/Karten-Integration",
  "feature_gps_desc": "Standortbasierte Funktionen und Kartierung",
  "feature_backend": "Backend mit Datenbank",
  "feature_backend_desc": "Server- und Datenbankinfrastruktur",
  "feature_admin": "Admin-Panel",
  "feature_admin_desc": "Dashboard zur Verwaltung Ihrer App",
  "feature_api": "API-Integration",
  "feature_api_desc": "Verbindung mit externen Diensten",
  "feature_push": "Push-Benachrichtigungen",
  "feature_push_desc": "Echtzeit-Benachrichtigungen an Benutzer",
  "feature_offline": "Offline-Modus",
  "feature_offline_desc": "App-Funktionalität ohne Internet",
  "feature_cloud": "Cloud-Synchronisation",
  "feature_cloud_desc": "Datensynchronisation über Geräte hinweg",
  
  // User Volume Step
  "volume_title": "Mit wie vielen Benutzern rechnen Sie?",
  "volume_subtitle": "Wählen Sie das erwartete Benutzervolumen für Ihre Anwendung",
  "volume_selected": "Ausgewähltes Volumen:",
  "volume_cost": "Zusätzliche Kosten:",
  "volume_small": "Klein (Bis zu 100 Benutzer)",
  "volume_medium": "Mittel (Bis zu 1.000 Benutzer)",
  "volume_large": "Groß (Bis zu 100.000 Benutzer)",
  "volume_enterprise": "Enterprise (100.000+ Benutzer)",
  
  // Maintenance Step
  "maintenance_title": "Benötigen Sie Wartung & Support?",
  "maintenance_subtitle": "Wählen Sie einen Wartungsplan oder überspringen Sie diesen Schritt",
  "maintenance_6": "6 Monate Wartung",
  "maintenance_6_desc": "Fehlerbehebungen und kritische Updates für 6 Monate",
  "maintenance_12": "12 Monate Wartung",
  "maintenance_12_desc": "Fehlerbehebungen, Updates und kleinere Verbesserungen für 1 Jahr",
  "maintenance_24": "24 Monate Wartung",
  "maintenance_24_desc": "Vollständiger Support, Updates und Funktionsverbesserungen für 2 Jahre",
  "maintenance_none": "Kein Wartungsplan benötigt",
  
  // Navigation
  "btn_next": "Weiter",
  "btn_previous": "Zurück",
  "btn_results": "Ergebnisse anzeigen",
  
  // Footer
  "footer_copyright": "© {{year}} onexip. Alle Rechte vorbehalten.",
  
  // Language
  "language": "Sprache",
  "language_en": "Englisch",
  "language_de": "Deutsch"
};
